import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import useCorporateBondScreenerMySelection, {
  type ICorporateBondScreenerMySelectionValue,
} from './useCorporateBondScreenerMySelection';

const CorporateBondScreenerMySelectionContext =
  createContext<ICorporateBondScreenerMySelectionValue | null>(null);

export const useCorporateBondScreenerMySelectionContext = (): ICorporateBondScreenerMySelectionValue => {
  const context = useContext(CorporateBondScreenerMySelectionContext);

  if (!context) {
    throw new Error('useCorporateBondScreenerMySelectionContext must be used within CorporateBondScreenerMySelectionContextProvider');
  }

  return context;
};

export const CorporateBondScreenerMySelectionContextProvider = ({ children }: PropsWithChildren): ReactElement => (
  <CorporateBondScreenerMySelectionContext.Provider value={ useCorporateBondScreenerMySelection() }>
    { children }
  </CorporateBondScreenerMySelectionContext.Provider>
);
